<!--begin::Menu wrapper-->
<ng-container *ngIf=" (routesSubject | async)">
  <div
    id="kt_app_sidebar_menu_wrapper"
    class="app-sidebar-wrapper hover-scroll-overlay-y my-10"
    data-kt-scroll="true"
    data-kt-scroll-activate="true" data-kt-scroll-height="auto"
    data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
    data-kt-scroll-wrappers="#kt_app_sidebar_menu"
    data-kt-scroll-offset="5px"
    data-kt-scroll-save-state="true"
  >

    <!--begin::Menu-->
    <div
      class="menu menu-column menu-rounded menu-sub-indention px-3"
      id="#kt_app_sidebar_menu"
      data-kt-menu="true"
      data-kt-menu-expand="false"
    >
      <ng-container *ngFor="let route of routes">
        <ng-container *ngIf="route.data">

          <!-- MENU HAS CHILDREN -->
          <ng-container *ngIf="route.data.children.length; else noChildren">
            <!-- <ng-container *ngSwitchCase="true"> -->
            <div class="menu-item menu-accordion" data-kt-menu-trigger="click" routerLinkActive="menu-active-bg">
            <span class="menu-link">
              <span class="menu-icon">
                <span class="svg-icon svg-icon-2" inlineSVG="./assets/media/icons/{{route.data.icon}}"></span>
              </span>
              <span class="menu-title">{{ route.data.label }}</span>
              <span class="menu-arrow"></span>
            </span>

              <!-- SUB-CHILD -->
              <div *ngIf="route.data.children.length" class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
                <ng-container *ngFor="let sub of route.data.children">
                  <div class="menu-item menu-accordion" data-kt-menu-trigger="click">
                    <ng-container *ngIf="sub.children.length; else subChildNoChildren">
                      <span class="menu-link">
                        <a routerLink="{{sub.path}}">
                          <span class="menu-title ps-6 pe-8">{{ sub.label }}</span>
                        </a>
                        <span class="menu-arrow"></span>
                      </span>
                    </ng-container>

                    <!-- MENU SUB CHILDREN NO CHILD-->
                    <ng-template #subChildNoChildren>
                      <div class="ps-6 pe-8">
                        <a
                          class="menu-link without-sub"
                          routerLinkActive="active"
                          routerLink="{{ sub.path }}"
                        >
                          <span class="menu-title">{{ sub.label }}</span>
                        </a>
                      </div>
                    </ng-template>

                    <!-- SUB-CHILD CHILDREN -->
                    <ng-container *ngIf="sub.children.length">
                      <!-- {{ sub.children | json }} -->
                      <ng-container *ngFor="let subchild of sub.children">
                        <div class="menu-sub menu-sub-accordion" routerLinkActive="menu-active-bg">
                          <div class="menu-item">
                            <a
                              class="menu-link without-sub ps-6 pe-8"
                              routerLinkActive="active"
                              routerLink="{{ subchild.path }}"
                            >
                              <span class="sub-menu-title">{{ subchild.label }}</span>
                            </a>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </div>
            <!-- </ng-container> -->
          </ng-container>
          <!-- MENU NO CHILDREN -->
          <ng-template #noChildren>
            <div class="menu-item">
              <a routerLink="{{ route.path }}" class="menu-link without-sub" routerLinkActive="{{ route.data.activeClass }}">
            <span class="menu-icon">
              <span class="svg-icon svg-icon-2" inlineSVG="./assets/media/icons/{{route.data.icon}}"></span>
            </span>
                <span class="menu-title">{{route.data.label}}</span>
              </a>
            </div>
          </ng-template>

        </ng-container>
      </ng-container>
    </div>
    <!--end::Menu-->
  </div>

</ng-container>
<!--end::Menu wrapper-->
